<pdq-card variant="popover" color="white">
  <div class="card">
    <div class="card__header goal-header">
      <pdq-heading element="h5">Goal {{ index + 1 }}</pdq-heading>
      @if (isAutoApplyBlockedByDisplayConditions) {
        <span class="threshold-error">Turn off auto-apply or remove display conditions</span>
      }
      <div class="goal-header__actions">
        <pdq-slide-toggle
          [defaultValue]="isOnlyGoal ? true : goal.controls.enabled.value"
          [locked]="isOnlyGoal"
          (onToggle)="goal.controls.enabled.setValue($event)"></pdq-slide-toggle>
        @if (index > 0) {
          <pdq-button
            icon="trash"
            variant="ghost"
            plain="true"
            size="medium"
            iconColor="var(--error-default)"
            (onClick)="remove.emit()"></pdq-button>
        }
        <pdq-button
          class="collapse-chevron"
          [class.collapse-chevron--open]="!collapsed"
          icon="arrow_down"
          variant="ghost"
          plain="true"
          size="large"
          iconColor="var(--on-surface-default)"
          (onClick)="toggleCollapsed()"></pdq-button>
      </div>
    </div>

    @if (!collapsed) {
      <pdq-divider></pdq-divider>
      <div class="card__content">
        <pdq-tabs-group variant="underline" leftMargin="none" (onChange)="setActiveTab($any($event))">
          <pdq-tab label="Threshold" value="threshold" [active]="activeTab === 'threshold'"></pdq-tab>
          <pdq-tab label="Offer" value="offer" [active]="activeTab === 'offer'"></pdq-tab>
          <pdq-tab label="Appearance" value="appearance" [active]="activeTab === 'appearance'"></pdq-tab>
        </pdq-tabs-group>

        @switch (activeTab) {
          @case ('threshold') {
            <smart-cart-goal-threshold-tab
              [goal]="goal"
              [index]="index"
              [minimumThresholdType]="minimumThresholdType"
              [thresholdErrors]="thresholdErrors"></smart-cart-goal-threshold-tab>
          }
          @case ('offer') {
            <smart-cart-goal-offer-tab [goal]="goal"></smart-cart-goal-offer-tab>
          }
          @case ('appearance') {
            <smart-cart-goal-appearance-tab
              [goal]="goal"
              [barType]="barType"
              [pillsEnabled]="pillsEnabled"
              [globalSettingsFormGroup]="globalSettingsFormGroup"
              [smartCartId]="smartCartId"
              [usageToken]="usageToken"></smart-cart-goal-appearance-tab>
          }
        }
      </div>
    }
  </div>
</pdq-card>
